import React from 'react';
import cn from 'classnames';

import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';

import { ContextMenu } from 'components/ContextMenu';
import { Popover } from 'components/Popover';

import styles from './CreateButton.module.scss';

const CreateButton = ({
  buttonText,
  contextItems,
  onContextItemClick,
}: {
  buttonText: any;
  contextItems: any;
  onContextItemClick: any;
}) => (
  <Popover
    placement="bottom-end"
    triggerElement={({ isMounted }: { isMounted: any }) => (
      <Button
        className={cn(styles.btn, { [styles.btnActive]: isMounted })}
        size="md"
        variant="link"
        startIcon={<Icon name="plusRound" />}
      >
        {buttonText}
      </Button>
    )}
  >
    <ContextMenu
      className={styles.menu}
      items={contextItems}
      onItemClick={(contextItem: any) => onContextItemClick(contextItem)}
    />
  </Popover>
);

export default React.memo(CreateButton) as any;
